import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import store from "../../../store";


class CheckBlockedChannels extends AbstractRequestTask {

  constructor(group_id = '', version = 'v2') {
    super();
    this.group_id = group_id;
    this.version = version;
    this.params = super.getParams();
    this.user_token = this.params.user_token;
  }

  getUrl() {
    const protocol = 'https';
    const server = Launcher.get("akamai_mfwk");
    const endpoint = 'services/user';
    const version = this.version;
    const apiname = 'controlpin/channels/check';
    
    return `${protocol}://${server}/${endpoint}/${version}/${apiname}`;
  }

  getParams() {
    const params = super.getParams();
    const group_id = this.group_id;
    const user = store.getState().user;
    const user_id = user.user_id || "";
    delete params.api_version;
    delete params.HKS;
    delete params.user_token
    return Object.assign({}, params, { user_id, group_id });
  }

   getHeaders() {
        return {
            'Authorization': `Bearer ${this.user_token}`,
            'Accept-Language': this.acceptLanguage
        }
    }

  isValid(data) {
    if (data.errors || data.status == 1 || data.response === 'error') {
      return false;
    }
    return true;
  }

  success(data, b) {
    this.resolve(data);
  }
}

export default CheckBlockedChannels;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/CheckBlockedChannelsTask.js